import { api } from '..';
import { AuditLogs, AuditLogsData } from './types';

export const auditLogsApi = api.enhanceEndpoints({ addTagTypes: ['AuditLogs'] }).injectEndpoints({
  endpoints: build => ({
    getAuditLogsList: build.query<AuditLogsData, { offset: number; limit: number; filter: string; sort: string }>({
      query: ({ offset, limit, filter, sort }) => ({
        url: `v1/audit-logs?offset=${offset || 0}&limit=${limit || 5}${filter || ''}${
          sort ? `&sort=${sort}` : '&sort=createdAt desc'
        }`,
        method: 'GET',
      }),
    }),
    getAuditLogsByEntity: build.query<AuditLogs[], { entityType: string; entityId: number }>({
      query: ({ entityType, entityId }) => ({
        url: `v1/audit-logs/entity/${entityType}/${entityId}`,
        method: 'GET',
      }),
    }),
    getAuditLogsByActor: build.query<AuditLogs[], { actorId: number }>({
      query: ({ actorId }) => ({
        url: `v1/audit-logs/actor/${actorId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetAuditLogsListQuery, useLazyGetAuditLogsByEntityQuery, useLazyGetAuditLogsByActorQuery } =
  auditLogsApi;
